import { useMutation } from '@tanstack/react-query'

import { changeToTheSpecifiedEkycResult } from '@src/api'
import { DefaultApiChangeToTheSpecifiedEkycResultRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useChangeToTheSpecifiedEkycResult = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiChangeToTheSpecifiedEkycResultRequest) =>
      changeToTheSpecifiedEkycResult(axiosInstance, params),
  })
}
